/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import { updateClipCropStatusBodySchema } from '../updateClipCropStatus/update-clip-crop-status-request';

export const updateClipCropStatusV2BodySchema = updateClipCropStatusBodySchema.extend({
  verticalFileSizeKb: z.number().int().nullable().optional(),
});

export type IUpdateClipCropStatusV2Body = z.infer<typeof updateClipCropStatusV2BodySchema>;

export interface IUpdateClipCropStatusV2Request {
  clipId: number;
  body: IUpdateClipCropStatusV2Body;
}
